import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { ILeagueApiListResponse, ILeagueDeleteParams, ILeagueDeleteResponse, ILeagueUpdateParams, ILeagueUpdateResponse } from '@/types/league';

export const leagueList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<ILeagueApiListResponse>> => {
    return axios.get('/api/league/list', { ...config, params });
};

export const leagueDelete = (params: ILeagueDeleteParams): Promise<AxiosResponse<ILeagueDeleteResponse>> => {
    return axios.post('/api/league/delete', params);
};

export const leagueUpdate = (params: ILeagueUpdateParams): Promise<AxiosResponse<ILeagueUpdateResponse>> => {
    return axios.post('/api/league/update', params);
};
